var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map(function(p){return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = function(scope, key) {
	return scope && __webpack_require__.o(scope, key);
}
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = function(versions) {
	return Object.keys(versions).reduce(function(filtered, version) {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = function(scope, key, eager) {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = function(scope, key, requiredVersion, eager) {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key, eager) {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion, eager) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = function(msg) {
	throw new Error(msg);
}
var failAsNotExist = function(scopeName, key) {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ function(msg) {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = function(fn) { return function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
}; };

var useFallback = function(scopeName, key, fallback) {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init(function(scopeName, scope, key, eager, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key, eager, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	45452: function() { return loadStrictSingletonVersion("default", "react", false, [,[1,18],[-1,18],1,[0,17],2], function() { return __webpack_require__.e(540).then(function() { return function() { return __webpack_require__(96540); }; }); }); },
	95648: function() { return loadStrictSingletonVersion("default", "react-dom", false, [,[1,18],[-1,18],1,[0,17],2], function() { return __webpack_require__.e(961).then(function() { return function() { return __webpack_require__(40961); }; }); }); },
	18668: function() { return loadStrictSingletonVersion("default", "@emotion/react", false, [,[1,11],[-1,11],1,[0,10],2], function() { return __webpack_require__.e(587).then(function() { return function() { return __webpack_require__(15587); }; }); }); },
	7988: function() { return loadStrictSingletonVersion("default", "@emotion/styled", false, [,[1,11],[-1,11],1,[0,10],2], function() { return __webpack_require__.e(196).then(function() { return function() { return __webpack_require__(69815); }; }); }); },
	22052: function() { return loadSingletonVersion("default", "@copilotkit/react-core/v2", false, [4,1,60,1], function() { return Promise.all([__webpack_require__.e(389), __webpack_require__.e(689)]).then(function() { return function() { return __webpack_require__(31469); }; }); }); },
	52986: function() { return loadStrictSingletonVersion("default", "axios", false, [,[2,0,27],[-1,0,27],1,[0,0,26],2], function() { return __webpack_require__.e(505).then(function() { return function() { return __webpack_require__(72505); }; }); }); },
	58755: function() { return loadStrictVersion("default", "ilenia", false, [1,9,11,2], function() { return __webpack_require__.e(863).then(function() { return function() { return __webpack_require__(40863); }; }); }); },
	59993: function() { return loadStrictSingletonVersion("default", "axios", false, [,[2,0,27],[-1,0,27],1,[0,0,26],2], function() { return __webpack_require__.e(844).then(function() { return function() { return __webpack_require__(75844); }; }); }); },
	86518: function() { return loadStrictVersion("default", "ilenia", false, [1,9,11,1], function() { return __webpack_require__.e(863).then(function() { return function() { return __webpack_require__(40863); }; }); }); }
};
// no consumes in initial chunks
var chunkMapping = {
	"452": [
		45452
	],
	"599": [
		7988,
		22052,
		52986,
		58755,
		59993,
		86518
	],
	"648": [
		95648
	],
	"668": [
		18668
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}